/**
 * Quick Add Direct — single-variant add-to-cart from collection cards.
 * Custom element <quick-add-direct> wraps a button with data-variant-id.
 * On click: AJAX POST to /cart/add.js, then opens the cart drawer.
 */
if (!customElements.get('quick-add-direct')) {
  customElements.define(
    'quick-add-direct',
    class QuickAddDirect extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.card__quick-add-btn--direct');
        if (this.button) {
          this.button.addEventListener('click', this.handleClick.bind(this));
        }
      }

      async handleClick(e) {
        e.preventDefault();
        e.stopPropagation();

        if (this.button.getAttribute('aria-disabled') === 'true') return;

        const variantId = this.button.dataset.variantId;
        if (!variantId) return;

        // Loading state
        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        const spinner = this.button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const cart = document.querySelector('cart-drawer');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        try {
          const response = await fetch(`${routes.cart_add_url}`, config);
          const data = await response.json();

          if (data.status) {
            // Error (e.g., sold out)
            console.error('Quick add error:', data.description);
            return;
          }

          // Success — update cart
          if (cart) {
            cart.renderContents(data);
          } else {
            window.location = window.routes.cart_url;
          }
        } catch (err) {
          console.error('Quick add fetch error:', err);
        } finally {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        }
      }
    }
  );
}
